import PropTypes from 'prop-types'
import React from 'react'
import "./CurrentParameters.scss"
import Modal from "../../../partials/Modal/SimpleModal/SimpleModal";
import Button from "../../../partials/Button";
import Scroll from '../../../partials/Scroll/Scroll';

function CurrentParameters({ currentParameters, onClick}) {

    return (
        <div className={"currentparameters_container"} onClick={onClick}>
            <Scroll>
                <div className={"content_wrapper"}>
                    <div className={"currentParameters_section"}>
                        <div className={"currentparameters_header"}>Satellite Parameters</div>
                        <ul>
                            <li>Size: {currentParameters.satellite.size} m3</li>
                            <li>Mass: {currentParameters.satellite.mass} Kg</li>
                            <li>Orbit: {currentParameters.satellite.orbit} </li>
                        </ul>
                    </div>
                    <div className={"currentParameters_section"}>
                        <div className={"currentparameters_header"}>Selected Rocket </div>
                        <ul>
                            <li>Model: {currentParameters.rocket.name}</li>
                            {currentParameters.rocket?.custom.map(p => {
                                return <li key={p.description}>{p.description}</li>
                            })}
                        </ul>
                    </div>

                    <div className={"currentParameters_section"}>
                        <div className={"currentparameters_header"}>Decisions</div>
                        <ul>
                            {currentParameters && currentParameters.decisions.map((d) => {
                                return <li key={d.description}>{d.description}</li>
                            })}
                            {currentParameters && currentParameters.decisions.length < 1 && <li>Not yet taken</li>}
                        </ul>
                    </div>

                    <div className={"break"} />
                    <div className={"currentparameters_section"} >
                        <div className={"currentparameters_header"}>Location</div>
                        <ul>
                            <li>Name: {currentParameters.location.name || 'TBD'}</li>
                            <li>Description: {currentParameters.location.description || 'TBD'} </li>
                        </ul>
                    </div>
                </div>
            </Scroll>
        </div>
    )
}

export default CurrentParameters;

CurrentParameters.propTypes = {
    currentParameters: PropTypes.object,
    show: PropTypes.bool
}
